/** Created by azhou on 2018/11/30.*/
<template>
  <div class="echart-wrap">
    <div class="d-center-start text-white w-100">
      今日活跃用户：{{AdminDataDetail.today_active_count}}
      <span class="ml-4">今日注册用户：{{AdminDataDetail.today_reg_count}}</span>
      <span class="ml-4">今日发布订单：{{AdminDataDetail.today_send_count}}</span>
      <span class="ml-4">今日成交订单：{{AdminDataDetail.today_deal_count}}</span>
      <span class="ml-4">今日成交金额：{{AdminDataDetail.today_deal_price  | formatMoney}}元</span>
      <span class="ml-4">今日线上支付:{{AdminDataDetail.today_price_pay/100 | formatMoney}}元</span>
      <el-popover placement="bottom" title="选择查询时间(发布订单时间)" trigger="click" class="ml-auto">
        <div class="d-flex align-items-center">
          <el-date-picker v-model="startMonth"
                          type="month"
                          class="mr-2" size="small"
                          value-format="yyyy-MM"
                          placeholder="开始时间" />
          <el-date-picker v-model="endMonth"
                          type="month" size="small"
                          value-format="yyyy-MM"
                          placeholder="结束时间" />
        </div>
        <label class="text-link" slot="reference"><i class="el-icon-search"></i>搜索</label>
      </el-popover>
      <!-- <label class="ml-3 text-link" @click="$emit('closeEchart')"><i class="el-icon-refresh"></i>切换表格模式</label> -->
    </div>
    <div class="e-data">
      <!--用户和总计数据-->
      <div class="text-left left-data" style="width: 350px;">
        <el-select v-model="showDetail" class="w-100" id="userSelect">
          <el-option v-for="item in groupData"
                     :key="item.type"
                     :label="item.title"
                     :value="item.type">
          </el-option>
        </el-select>
        <div v-for="(item,index) in currentUserData.childData" class="mb-1" :key="index">
          <div v-if="item.key == 'total_pay_price' || item.key == 'offline_pay'"></div>
          <div v-else class="d-center-between">
            {{item.name}}
            <span v-if="item.valueType==='money'">&yen; {{AdminDataDetail[item.key]/100 | formatMoney}} 元</span>
            <span v-else>{{AdminDataDetail[item.key]}}</span>
          </div>
        </div>
        <div class="text-center mt-1" @click="showDataDetail(currentUserData.type)">
          <span class="text-link">{{(showDetail === chartType && !showMap) ?'收起':'查看更多'}}</span>
        </div>
        <!--总计数据-->
        <p class="text-warning mt-auto mb-2">{{sumData.title}}</p>
        <div v-for="item in sumData.childData" class="d-center-between mb-1" :key="item.key">
          {{item.name}}
          <span v-if="item.valueType==='money'">&yen;<span>{{item.key=='price_pay'?totalData[item.key]/100:totalData[item.key] | formatMoney}}</span>元</span>
          <span v-else>{{totalData[item.key]}}</span>
        </div>
        <div class="text-center mt-1" @click="showDataDetail(sumData.type)">
          <span class="text-link">{{chartType === sumData.type ?'收起':'查看更多'}}</span>
        </div>
      </div>
      <div class="w-100">
        <!--echart地图-->
        <transition name="fade">
          <e-map v-show="showMap" :dataSet="mapDataSet" class="map-wrap m-auto"/>
        </transition>
        <!--数据表格-->
        <transition name="fade">
          <div class="bar-wrap" v-if="!showMap">
            <el-scrollbar style="height:100%;">
              <div class="text-white font-weight-bold text-center h4 mb-4">
                {{currentUserData.title}}
                <el-popover placement="bottom-end" width="300" trigger="hover" :content="tooltipText">
                  <span slot="reference"><i class="el-icon-question h6 ml-2 text-warning"></i></span>
                </el-popover>
              </div>
              <e-bar :DataSet="BarDataSet_1" class="mt-5 mb-5" :xAxisSet="BarxAxisSet"></e-bar>
              <e-line :DataSet="LineDataSet" class="mt-5 mb-i5" :xAxisSet="BarxAxisSet"></e-line>
              <e-pie :DataSet="PieDataSet_1" class="mt-5 mb-5" chartTitle="订单城市占比" mountId="e-pie-local"></e-pie>
              <!-- <e-pie :DataSet="PieDataSet_2" class="mt-5 mb-5" chartTitle="订单类型分类" mountId="e-pie-order"
                     v-if="chartType==='2'|| chartType==='0'"></e-pie> -->
              <div class="position-relative">
                <e-pie :DataSet="PieDataSet_3" class="mt-5 mb-5" chartTitle="认证城市占比" mountId="e-pie-user"
                       @clickPie="getUserDis"></e-pie>
                <div class="city-list">
                  <el-scrollbar style="height:100%;">
                    <div class="city-item-wrap">
                      <div class="d-center-between mb-1"
                           v-for="(cityItem,index) in disDataSet" :key="cityItem.title"
                           :class="{'mb-5':index===disDataSet.length-1}">
                        <span class="w-30 text-left">{{cityItem.title}}</span>
                        <span class="w-20 text-left">{{cityItem.value}}</span>
                        <span class="w-50 text-right">（{{cityItem.proportion}}）</span>
                      </div>
                    </div>
                  </el-scrollbar>
                </div>
              </div>
              <e-bar :DataSet="BarDataSet_2" :xAxisSet="BarxAxisSet" chartTitle="注册认证数据统计" mountId="e-line-user"></e-bar>
            </el-scrollbar>
          </div>
        </transition>
      </div>
    </div>
  </div>
</template>

<script>
  import {mapState,mapActions} from 'vuex'
  import EMap from './EMap'
  import EBar from './EBar'
  import EPie from './EPie'
  import ELine from './ELine'

  export default {
    data() {
      return {
        tooltipText:'2018年8月1日平台升级为2.0版本，在升级过程中，原1.0版本的数据库中订单存储的方式为单一存储，不适用新的订单存储方式，新订单改为一个订单可预订多家酒 店。所以把原数据库中统计的所有数值都保留在了2018年7月份中。致使7月份数据最高原因。',
        showDetail: '2',                    //当前查看的哪一个身份的用户数据
        showMap:true,
        groupData: [
          {
            title: '采购商统计数据',
            type: '2',
            childData: [
              {name: '认证数量', key: 'travel_verify_count', value: 0, valueType: 'normal'},
              {name: '发布过订单的采购商', key: 'travel_send_count', value: 0, valueType: 'normal'},
              {name: '成交过订单的采购商', key: 'travel_deal_count', value: 0, valueType: 'normal'},
              // {name: '发布订单总额', key: 'send_order_price', value: 0, valueType: 'money'},
              // {name: '成交订单总额', key: 'success_order_price', value: 0, valueType: 'money'},
              ]
          },
          {
            title: '酒店统计数据',
            type: '3',
            childData: [
              {name: '认证数量', key: 'hotel_verify_count', value: 0, valueType: 'normal'},
              {name: '报价过的酒店', key: 'hotel_offer_count', value: 0, valueType: 'normal'},
              {name: '成交过的酒店', key: 'hotel_deal_count', value: 0, valueType: 'normal'},
              // {name: '成交订单总额', key: 'success_order_price', value: 0, valueType: 'money'},
              // {name: '成交订单客单价', key: 'unit_price', value: 0, valueType: 'money'},
              ]
          },
          // {
          //   title: '民宿统计数据',
          //   type: '5',
          //   childData: [
          //     {name: '认证数', key: 'reg_nums', value: 0, valueType: 'normal'},
          //     {name: '订单总数', key: 'order_nos', value: 0, valueType: 'normal'},
          //     {name: '成交订单数', key: 'success_order_nos', value: 0, valueType: 'normal'},
          //     {name: '成交订单总额', key: 'success_order_price', value: 0, valueType: 'money'},
          //     {name: '成交订单客单价', key: 'unit_price', value: 0, valueType: 'money'},]
          // },
          // {
          //   title: '景区统计数据',
          //   type: '6',
          //   childData: [
          //     {name: '认证数', key: 'reg_nums', value: 0, valueType: 'normal'},
          //     {name: '订单门票数', key: 'order_ticket_nums', value: 0, valueType: 'normal'},
          //     {name: '成交订单数', key: 'success_order_nos', value: 0, valueType: 'normal'},
          //     {name: '成交订单总额', key: 'success_order_price', value: 0, valueType: 'money'}]
          // },
        ],
        sumData:{
          title: '统计数据合计',
          type: '0',
          childData: [
            {name: '用户注册', key: 'reg_count', value: 0, valueType: 'normal'},
            {name: '门店认证', key: 'verify_count', value: 0, valueType: 'normal'},
            {name: '发布订单', key: 'send_count', value: 0, valueType: 'normal'},
            {name: '成交订单', key: 'deal_count', value: 0, valueType: 'normal'},
            {name: '成交金额', key: 'deal_price', value: 0, valueType: 'money'},
            {name: '线上支付', key: 'price_pay', value: 0, valueType: 'money'},
            {name: '线下支付', key: 'offline_pay', value: 0, valueType: 'money'}]
        },
        chartType:'2',                     //图表当前展示的哪类数据：各种用户身份和合计
        totalData:{},
        BarxAxisSet: [],                   //横轴根据后台返回的年月的显示
        mapDataSet:[],                     //地图数据集合
        BarDataSet_1: [],                  //订单柱状图数据集合
        BarDataSet_2: [],                  //订单柱状图用户信息数据统计
        PieDataSet: [],                    //占比统计饼状图数据集合
        LineDataSet: [],                   //折线图数据集合
        PieDataSet_1: [],                  //饼状图订单地区分类
        PieDataSet_2: [],                  //饼状图订单类型分类，仅采购商和合计数据时展示
        PieDataSet_3: [],                  //饼状图用户地区分类
        disDataSet: [],                    //用户地区分类的市级数据
        currentData:{},                    //当天数据的信息
        startMonth:'',                     //查询数据的开始月份
        endMonth:'',                       //查询数据的结束月份
      }
    },
    computed: {
      ...mapState(['AdminDataDetail']),
      //按月份开始查询-开始月的第一天的0点
      startdate() {
        /*获取开始月的第一天*/
        if (this.startMonth) {
          let year = this.startMonth.split('-')[0];
          let month = this.startMonth.split('-')[1];
          let firstDay = new Date(year, month - 1, 1).getTime() / 1000;
          return Number(firstDay);
        } else return ''
      },
      //按月份开始查询-结束月的最后一天的23:59:59
      enddate() {
        /*获取结束月的最后一天*/
        if (this.endMonth) {
          let year = this.endMonth.split('-')[0];
          let month = this.endMonth.split('-')[1];
          let lastDay = new Date(year, month, 0).getTime() / 1000 + 86399;
          return Number(lastDay);
        } else return ''
      },
      //是否选择了开始月和结束月
      valuedMonth() {
        if (this.startdate && this.enddate) return this.startdate + this.enddate;
        return 0
      },
      //当前查看的用户数据
      currentUserData() {
        // if (this.chartType === '0') return this.sumData;
        return this.groupData.filter(v => v.type == this.showDetail)[0] || {};
      }
    },
    watch:{
      valuedMonth(newVal) {
        if (newVal) {
          if (this.enddate - this.startdate > 0) this.getAllDatas();
          else this._alert('结束月份应晚于开始月份', () => {
            this.startMonth = '';
            this.endMonth = '';
          },'warning');
        } else {
          this.startMonth = '';
          this.endMonth = '';
        }
      },
      //切换身份时查看
      showDetail(newVal) {
        this.chartType = newVal;
        this.getUserStateData({
          type:newVal,
          start_time:this.startdate,
          end_time:this.enddate
        })
        if (!this.showMap) this.getData(this.chartType);
      }
    },
    components: {EMap, EBar, EPie, ELine},
    async created() {
      //获取页面所有数据-可根据时间搜索
      this.getAllDatas();
      //获取当天数据-不需要根据时间搜索
      this.getCurrentData();
    },
    mounted() {
      let w = $(document).width()
      let h = $(document).height()
      $('.map-wrap').width(w * 0.58);
      $('.map-wrap').height(h * 0.85);
    },
    methods: {
      ...mapActions(['getUserStateData']),
      /*获取页面所有的统计数据*/
      async getAllDatas() {
        //当显示中国地图时拉取认证数，否则拉取某一选中身份的详细数据
        if (this.showMap) this.getRegNum();
        else this.getData(this.chartType);
        //获取当前选中的身份的相关数据
        // this.getUserStateData({
        //   type:this.chartType,
        //   start_time:this.startdate,
        //   end_time:this.enddate
        // });
        //获取管理员的用户数据
        this.totalData = await this.getUserStateData({
          type:this.sumData.type,
          start_time:this.startdate,
          end_time:this.enddate
        })
      },
      /*获取当天活跃数据*/
      async getCurrentData() {
        let res = await this.$axios.post('/pc/Admin/DataTotal',{});
        if (res.code === '00000') this.currentData = res.info;
      },
      /*获取各省份认证数*/
      async getRegNum() {
        let res = await this.$axios.post('/pc/Admin/MapVerifyTotal',{
          start_time:this.startdate,
          end_time:this.enddate
        });
        if (res.code === '00000') this.mapDataSet = res.info;
      },
      /*查看某一项的详细数据*/
      async showDataDetail(type) {
        this.showMap = !this.showMap;
        this.chartType = type;
        if (!this.showMap) this.getData(type);
      },
      async getData(type) {
        let loading = this.$loading({
          text: '数据加载中，请稍后.....',
          background: 'rgba(0, 0, 0, 0.8)',
          target: document.querySelector('.bar-wrap')
        });
        let res = await this.$axios.post('/pc/Admin/DataTotalYear',{
          type:this.chartType,
          start_time:this.startdate,
          end_time:this.enddate
        });
        loading.close();
        if (res.code === '00000') this.formatData(type, res);
      },
      /*整理后台获取的数据集合*/
      formatData(type, dataSet) {
        /*横轴的年份*/
        this.BarxAxisSet = dataSet.date_info.map(item => item.date);
        this.BarDataSet_1 = [
          {
            name: '发布订单',
            type: 'bar',
            color:'#f72221',
            data: dataSet.date_info.map(item => {
              return item.order_count_info.send_count
            }),
          },
          {
            name: '成交订单',
            type: 'bar',
            color:'#00C13C',
            data: dataSet.date_info.map(item => {
              return item.order_count_info.deal_count
            }),
          },
          {
            name: '支付订单',
            type: 'bar',
            color:'#61DAF3',
            data: dataSet.date_info.map(item => {
              return item.order_count_info.pay_count
            }),
          }];
        this.BarDataSet_2 = [
          // {
          //   name: '认证数',
          //   type: 'bar',
          //   data: dataSet.date_info.map(item => {
          //     return item.reg_nums
          //   }),
          // },
          {
            name: '用户注册',
            type: 'bar',
            color:'#f72221',
            data: dataSet.date_info.map(item => {
              return item.reg_verify.reg_count
            }),
          },
          {
            name: '门店认证',
            type: 'bar',
            color:'#00C13C',
            data: dataSet.date_info.map(item => {
              return item.reg_verify.verify_count
            }),
          }];
        this.PieDataSet_1 = dataSet.order_city_info ? dataSet.order_city_info.map(item => {
          return {value: item.order_count, name: item.city_name}
        }) : [];

        // this.PieDataSet_2 = dataSet.order_style_info ? dataSet.order_style_info.map(item => {
        //   return {value: item.count, name: `${this.$options.filters['formatVar'](item.order_style,'StoreType')}订单`}
        // }) : [];
        this.PieDataSet_3 = dataSet.verify_city_info ? dataSet.verify_city_info.map(item => {
          return {value: item. verify_count, name: item.city_name, provinceId: item.province}
        }) : [];
        this.LineDataSet = [
          // {
          //   name: '发布订单金额',
          //   type: 'line',
          //   data: dataSet.date_info.map(item => {
          //     return item.order_price_info.deal_price.toFixed(2)
          //   }),
          // },
          {
            name: '成交金额',
            type: 'line',
            data: dataSet.date_info.map(item => {
              return item.order_price_info.deal_price.toFixed(2)
            }),
          },
          {
            name: '支付金额',
            type: 'line',
            data: dataSet.date_info.map(item => {
              return (item.order_price_info.price_pay/100).toFixed(2)
            }),
          }
        ]
      },
      /*获取用户地区分类的城市信息*/
      async getUserDis(params) {
        $('.city-item-wrap').css({
          height: $('html,body').height() * 0.3 + 'px',
        });
        let res = await this.$axios.post('/pc/Admin/getUserCityList',{
          province: params.data.provinceId,
          store_type: this.showDetail
        })
        if (res.code === '00000') {
          this.disDataSet = res.info.map(item => {
            return {
              title: item.city_name,
              value: item.total_count_uses,
              proportion: item.proportion
            }
          })
        }
      }
    }
  }
</script>
<style lang="scss" scoped>
  .echart-wrap {
    position: fixed;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    background: #0f002b;
    color: #919191;
    z-index: 5;
    display: flex;
    align-items: center;
    justify-content: stretch;
    flex-direction: column;
    padding: 40px 20px 20px 40px;
    box-sizing: border-box;
    .e-data{
      width: 100%;
      height: 100%;
      display: flex;
      align-items: flex-start;
      margin-top: 30px;
      .left-data{
        height: 100%;
        display: flex;
        flex-direction: column;
      }
    }
  }
  ::v-deep #userSelect.el-input__inner{
    background: #0f002b;
    border: none;
    color: #fdb900;
    padding-left: 0;
  }
  ::v-deep #userSelect.el-input__icon{
    color: #fdb900!important;
  }
  .bar-wrap {
    position: absolute;
    top: 80px;
    left: 400px;
    padding: 20px;
    width: calc(100vh);
    height: 85%;
    .city-list {
      position: absolute;
      right: 20px;
      top: 50px;
      width: 20%;
      height: 250px;
      color: #fff;
    }
  }
</style>
